const IconTurbine = ({ color }) => {
  return (
    <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.7891 12.9673L23.3277 10.347C23.7082 10.1273 24.1947 10.2577 24.4143 10.6381L24.511 10.8056C25.1366 11.8891 25.1599 13.2184 24.5726 14.3231C23.8572 15.6689 22.2227 16.2322 20.83 15.613L18.8828 14.7471C18.136 14.415 18.0813 13.376 18.7891 12.9673Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M17.7891 16.7641L22.3277 19.3845C22.7082 19.6041 22.8385 20.0907 22.6189 20.4711L22.5222 20.6386C21.8966 21.7221 20.757 22.4069 19.5067 22.4507C17.9835 22.504 16.6784 21.3702 16.5184 19.8544L16.2946 17.7351C16.2088 16.9224 17.0813 16.3555 17.7891 16.7641Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M14 17.7968V23.0375C14 23.4769 13.6438 23.833 13.2045 23.833H13.0111C11.76 23.833 10.5972 23.1885 9.93412 22.1276C9.12631 20.8351 9.45569 19.138 10.6883 18.2415L12.4118 16.988C13.0728 16.5073 14 16.9795 14 17.7968Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M11.2109 15.0327L6.67232 17.653C6.29184 17.8727 5.80532 17.7423 5.58565 17.3619L5.48895 17.1944C4.86341 16.1109 4.84014 14.7816 5.42739 13.6769C6.14282 12.3311 7.77728 11.7678 9.16998 12.387L11.1172 13.2529C11.864 13.585 11.9187 14.624 11.2109 15.0327Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M12.2109 11.2359L7.67232 8.61552C7.29184 8.39585 7.16148 7.90933 7.38115 7.52885L7.47785 7.36136C8.10339 6.2779 9.24296 5.5931 10.4933 5.54932C12.0165 5.49599 13.3216 6.62981 13.4816 8.14556L13.7054 10.2649C13.7912 11.0776 12.9187 11.6445 12.2109 11.2359Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M16 10.2032V4.96249C16 4.52315 16.3562 4.16699 16.7955 4.16699H16.9889C18.24 4.16699 19.4028 4.81149 20.0659 5.87241C20.8737 7.1649 20.5443 8.86204 19.3117 9.75852L17.5882 11.012C16.9272 11.4927 16 11.0205 16 10.2032Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  )
}

export default IconTurbine
